import React from "react";
import { ToastOptions, toast } from "react-toastify";
import { Type } from "@linkfluence/models/notification";
import { Glyph } from "@ui-kit/icon";
import { Content } from "@ui-kit/notification";

export const DEFAULT_OPTIONS: ToastOptions = {
  position: "bottom-right",
  autoClose: 3000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

const getToast = (message: string, icon: Glyph, description?: string) => (
  <Content message={message} icon={icon} description={description} />
);

export const notify = (
  message: string,
  type: Type = Type.Success,
  description?: string,
  error?: string
) => {
  if (type === Type.Success) {
    toast.success(getToast(message, "check", description), DEFAULT_OPTIONS);
  } else if (type === Type.Info) {
    toast.info(getToast(message, "circle-info", description), DEFAULT_OPTIONS);
  } else if (type === Type.Warning) {
    toast.warning(
      getToast(message, "circle-info", description),
      DEFAULT_OPTIONS
    );
  } else if (type === Type.Error) {
    if (error) {
      console.error(error);
    }
    toast.error(getToast(message, "bang", description), DEFAULT_OPTIONS);
  }
};
